import styled from 'styled-components'
import { blue } from '../../color'

export const ExplorerToolbar = styled.div`
  background: #ffffff;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
`

export const SearchBox = styled.div`
  width: 100%;
  max-width: 400px;
  height: 36px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  &:hover {
    border-color: #40a9ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
  }

  &:focus-within {
    border-color: #40a9ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
  }

  .ant-input-search {
    width: 100%;
    &.ant-input-group-wrapper,
    .ant-input-group-wrapper,
    .ant-input-wrapper,
    .ant-input-group,
    .ant-input-affix-wrapper {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
      padding: 0 !important;
      height: 34px !important;
    }

    .ant-input {
      height: 34px !important;
      border: none !important;
      background: transparent !important;
      font-size: 14px;
      padding-right: 50px !important;
      padding-left: 12px !important;
      box-shadow: none !important;
      outline: none !important;
      color: #262626;

      &::placeholder {
        color: #bfbfbf;
      }

      &:focus {
        box-shadow: none !important;
        border: none !important;
      }
    }

    .ant-input-suffix {
      right: 16px;
      color: #999;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 0 4px;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #666;
      }

      .ant-input-clear-icon {
        font-size: 14px;
      }
    }

    .ant-input-group-addon {
      display: none !important;
    }
  }
`

export const FileTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead tr {
    border-bottom: 2px solid #f0f0f0;
  }

  thead th {
    padding: 10px 12px;
    text-align: left;
    color: #8c8c8c;
    font-weight: 600;
    font-size: 13px;
    white-space: nowrap;
    border-bottom: 1px solid #f0f0f0;
  }

  tbody tr {
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.2s;
    cursor: default;
  }

  tbody tr:hover {
    background: #f9f9f9;
  }

  tbody td {
    padding: 10px 12px;
    vertical-align: middle;
  }
`

export const SortableHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;

  &:hover {
    color: ${blue};
  }
`

export const SortIcon = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: ${p => (p.active ? blue : '#bfbfbf')};
`

export const ContentWrap = styled.div`
  min-height: calc(100vh - 150px);
`

export const EmptyWrap = styled.div`
  padding: 48px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PageTabsWrapper = styled.div`
  margin-bottom: 16px;

  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 10px 0 12px;
    font-weight: 500;
  }
`
export const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;

  /* Override FileItem's internal wrapping */
  div,
  span {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: keep-all !important;
  }

  .doc-name {
    font-weight: 500;
    color: #222;
    cursor: ${p => (p.isFolder ? 'pointer' : 'default')};
    flex: 1;

    &:hover {
      color: ${p => (p.isFolder ? blue : '#222')};
    }
  }
`

export const AdminPanel = styled.div`
  display: grid;
  gap: 16px;
`

export const AdminIntro = styled.div`
  padding: 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f7f9fc 100%);
  border: 1px solid #e8edf3;
`

export const AdminTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1f1f1f;
  margin-bottom: 6px;
`

export const AdminDescription = styled.div`
  color: #666;
  font-size: 13px;
  line-height: 1.6;
`

export const AdminShortcutGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
`

export const AdminShortcut = styled.button`
  border: 1px solid #d9e2ec;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 6px;

  &:hover {
    border-color: ${blue};
    box-shadow: 0 8px 20px rgba(24, 144, 255, 0.08);
    transform: translateY(-1px);
  }
`

export const AdminShortcutTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1f1f1f;
`

export const AdminShortcutMeta = styled.div`
  font-size: 12px;
  color: #6b7280;
`
export const TableScrollWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`
